export default __webpack_public_path__ + "static/media/Propital.05d890b3.png";